import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.substring(1); // '#'を除去
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth"}); // スムーズスクロール
      }
    }
  }, [location]);

  return null;
};

export default ScrollToHash;